import { useState } from "react";
import { Box, Collapse, Typography, IconButton } from "@mui/material";
import { ExpandMoreRounded, ExpandLessRounded, InfoOutlined, RuleFolderOutlined } from "@mui/icons-material";

/**
 * PageGuide — a brief, collapsible "About this page" callout: Why / What / How / When.
 * Plain-PM language. Place near the top of a page, under the title.
 *
 *   <PageGuide
 *     why="..." what="..." how="..." when="..."
 *   />
 */
const ROWS = [["Why", "why"], ["Who", "who"], ["What", "what"], ["How", "how"], ["When", "when"]];

export default function PageGuide({ why, who, what, how, when, standard, title = "About this page", defaultOpen = true, sx = {} }) {
  const [open, setOpen] = useState(defaultOpen);
  const data = { why, who, what, how, when };
  return (
    <Box sx={{ bgcolor: "#F4F5F7", border: "1px solid #E3E6EA", borderRadius: 1.5, mb: 2, ...sx }}>
      <Box
        onClick={() => setOpen(!open)}
        sx={{ display: "flex", alignItems: "center", gap: 1, px: 2, py: 1, cursor: "pointer", userSelect: "none" }}
      >
        <InfoOutlined sx={{ fontSize: 18, color: "#F88F1D" }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#374151", flexGrow: 1 }}>{title}</Typography>
        <IconButton size="small" aria-label={open ? "Collapse" : "Expand"}>
          {open ? <ExpandLessRounded /> : <ExpandMoreRounded />}
        </IconButton>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ px: 2, pb: 1.5, pt: 0.25, display: "grid", gap: 0.75 }}>
          {ROWS.map(([label, key]) =>
            data[key] ? (
              <Box key={key} sx={{ display: "flex", gap: 1.25 }}>
                <Typography variant="caption" sx={{ fontWeight: 700, color: "#F88F1D", minWidth: 44, textTransform: "uppercase", letterSpacing: 0.5, mt: "1px" }}>
                  {label}
                </Typography>
                <Typography variant="body2" sx={{ color: "#4B5563", lineHeight: 1.5 }}>{data[key]}</Typography>
              </Box>
            ) : null
          )}
          {standard && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 0.5, pt: 0.75, borderTop: "1px dashed #E3E6EA" }}>
              <RuleFolderOutlined sx={{ fontSize: 15, color: "#6B7280", flexShrink: 0 }} />
              <Typography variant="caption" sx={{ fontWeight: 700, color: "#6B7280", textTransform: "uppercase", letterSpacing: 0.5 }}>Complies with</Typography>
              <Typography variant="body2" sx={{ color: "#374151", fontWeight: 600 }}>{standard}</Typography>
            </Box>
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
